<template>
  <div id="PaymentReminderNotice">
    <section class="content-area">
      <div class="title">
        親愛的永豐會員您好:
      </div>

      <div class="description">
        <p>
          契約編號:<span class="red">{{ data.number }}</span>
          互助人:<span class="red">{{ data.member_name }}</span>
          您參與永豐安家寶<span class="red">{{ removeZerosAndFormat(data.full_amount, 4) }}</span>萬契約不知不覺已繳滿獲得終身保障不用再繳互助費
        </p>

        <p>
          <span class="font-bold ">惟您申請墊繳款項尚未還款,每個月有手續費仍需繳納</span>,特此提醒您
        </p>

        <p>
          我們在此表達對您的關懷與感恩,同時祝福您身體健康萬壽無疆
        </p>

        <p>
          若您要再增加新保契約或有需要為您服務的地方請與我們聯絡
        </p>
      </div>
    </section>

    <section class="company-area">
      <p>客務專線：04-23149111</p>

      <p>客服LINE：@YF42669258</p>

      <p>生命禮儀24小時諮詢：0809-001339</p>

      <p class="slogan">永豐網路平台股份有限公司</p>
    </section>

    <section class="date-area">
      <p>
        <span>中</span>
        <span>華</span>
        <span>民</span>
        <span>國</span>
        <span class="red">{{ getTodayDate(true, true).year }}</span>年
        <span class="red">{{ getTodayDate(true, true).month }}</span>月
        <span class="red">{{ getTodayDate(true, true).day }}</span>日
      </p>
    </section>
  </div>
</template>

<script>
import { convertRocDate, getTodayDate, removeZerosAndFormat } from "@/models/HELPERS/common.js";

export default {
  name: 'BehalfDebtPaymentFullNotice',
  props: {
    data: {
      type: Object,
      required: false,
      default: () => {}
    },
  },
  watch: {
    'data.id': {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          // this.generateBarcode();
        });
      },
      immediate: false
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  mounted() {
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      // this.$nextTick(() => {
      // });
    },
    convertRocDate,
    getTodayDate,
    removeZerosAndFormat
  }
}
</script>

<style lang="scss" scoped>
* {
  font-family: DFKai-sb;
}

#PaymentReminderNotice {
  width: 794px;
  height: 560px;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  p {
    margin: 0;
  }
  .red {
    color: red;
  }
  .font-bold {
    font-weight: bold;
  }
  .content-area {
    width: 100%;
    // background: #ffffcc;
    // padding: 10px;
    .title {
      font-size: 26px;
      font-weight: 500;
    }
    .description {
      margin-top: 15px;
      font-size: 26px;
      font-weight: 500;
      line-height: 2;
    }
  }
  .company-area {
    width: 100%;
    margin-top: 30px;
    font-size: 18px;
    font-weight: bold;
    margin-top: auto;
    .slogan {
      margin-top: 10px;
      font-weight: 500;
      text-align: right;
      font-size: 22px;
    }
  }
  .date-area {
    font-size: 26px;
    font-weight: 500;
    margin-top: 30px;
    p {
      display: flex;
      justify-content: space-between;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/PrintTemplate/BehalfDebtPaymentFullNotice.vue